import React, { useContext, useState, useRef, useEffect } from 'react';
import { Nav, Navbar, Container, Form, FormControl, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { LanguageContext } from './LanguageContext';
import logo from '../assets/001.jpg';
import KG from '../assets/kyr.png';
import RU from '../assets/rus.png';
import catalogData from '../locales/catalogData.json';

import '../styles/Header.css';

const phrases = [
    "Экран для банкомата",
    "Принтер чеков",
    "Банкомат",
    "POS терминал"
];

const Header = () => {
    const { setLanguage, language } = useContext(LanguageContext);
    const [menuOpen, setMenuOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredResults, setFilteredResults] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [autoText, setAutoText] = useState('');
    const [isUserTyping, setIsUserTyping] = useState(false);

    const navbarRef = useRef(null);
    const searchRef = useRef(null);
    const timerRef = useRef(null);
    const phraseIndex = useRef(0);
    const charIndex = useRef(0);
    const isDeleting = useRef(false);

    const navigate = useNavigate();

    const messages_ru = { home: "На Главную", catalog: "Каталог", about: "О нас", services: "Сервис", contact: "Контакты" };
    const messages_kg = { home: "Башкы бет", catalog: "Каталог", about: "Биз жөнүндө", services: "Кызмат", contact: "Байланыш" };
    const getMessage = key => (language === 'kg' ? messages_kg[key] : messages_ru[key]);

    useEffect(() => {
        const handleOutside = e => {
            if (navbarRef.current && !navbarRef.current.contains(e.target)) setMenuOpen(false);
        };
        document.addEventListener('mousedown', handleOutside);
        return () => document.removeEventListener('mousedown', handleOutside);
    }, []);

    useEffect(() => {
        const handleOutside = e => {
            if (searchRef.current && !searchRef.current.contains(e.target)) setShowDropdown(false);
        };
        document.addEventListener('mousedown', handleOutside);
        return () => document.removeEventListener('mousedown', handleOutside);
    }, []);

    useEffect(() => {
        if (isUserTyping) { clearTimeout(timerRef.current); return; }
        const tick = () => {
            const phrase = phrases[phraseIndex.current] || '';
            if (!isDeleting.current) {
                charIndex.current++;
                setAutoText(phrase.substring(0, charIndex.current));
                if (charIndex.current === phrase.length) {
                    isDeleting.current = true;
                    timerRef.current = setTimeout(tick, 2000);
                } else {
                    timerRef.current = setTimeout(tick, 150);
                }
            } else {
                charIndex.current--;
                setAutoText(phrase.substring(0, charIndex.current));
                if (charIndex.current === 0) {
                    isDeleting.current = false;
                    phraseIndex.current = (phraseIndex.current + 1) % phrases.length;
                    timerRef.current = setTimeout(tick, 700);
                } else {
                    timerRef.current = setTimeout(tick, 75);
                }
            }
        };
        timerRef.current = setTimeout(tick, 500);
        return () => clearTimeout(timerRef.current);
    }, [isUserTyping]);

    const highlightMatch = (text, query) => {
        if (!query) return text;
        const parts = text.split(new RegExp(`(${query})`, 'gi'));
        return parts.map((part, i) =>
            part.toLowerCase() === query.toLowerCase() ?
                <mark key={i}>{part}</mark> :
                <span key={i}>{part}</span>
        );
    };

    const handleSearchChange = e => {
        const value = e.target.value;
        setSearchQuery(value);
        setIsUserTyping(true);
        if (value.trim()) {
            const low = value.toLowerCase();
            const items = catalogData[language] || catalogData['ru'];
            const matches = items.filter(item =>
                item.model.toLowerCase().includes(low) ||
                item.id.toLowerCase().includes(low) ||
                item.shortDescription.toLowerCase().includes(low)
            );
            setFilteredResults(matches);
            setShowDropdown(true);
        } else {
            setFilteredResults([]);
            setShowDropdown(false);
        }
    };

    const handleResultClick = item => {
        setSearchQuery(item.id);
        setShowDropdown(false);
        setIsUserTyping(false);
        navigate(`/search?q=${encodeURIComponent(item.id)}`);
    };

    const handleSearchSubmit = e => {
        e.preventDefault();
        if (searchQuery.trim()) {
            navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
            setSearchQuery('');
            setShowDropdown(false);
            setIsUserTyping(false);
        }
    };

    const changeLanguage = lang => {
        setLanguage(lang);
        localStorage.setItem('language', lang);
    };


    return (
        <Navbar fixed="top" collapseOnSelect expand="md" bg="black" variant="dark" expanded={menuOpen} ref={navbarRef}>
            <Container>
                <Navbar.Brand as={Link} to="/" className="d-flex align-items-center gap-2">
                    <img src={logo} alt="Logo" height="35" width="45" style={{ objectFit: 'contain' }} />
                    <span className="text-white fw-bold fs-5">UNITECH</span>
                </Navbar.Brand>
                <Navbar.Toggle onClick={() => setMenuOpen(o => !o)} />
                <Navbar.Collapse>
                    <Nav className="m-lg-auto" onClick={() => setMenuOpen(false)}>
                        {['home','catalog','services','contact','about'].map(key => (
                            <Nav.Link key={key} as={Link} to={key==='home'?'/':`/${key}`} className="text-white">
                                {getMessage(key)}
                            </Nav.Link>
                        ))}
                    </Nav>
                    <div ref={searchRef} className="position-relative d-flex ms-auto me-3" style={{ maxWidth: '350px' }}>
                        <Form className="d-flex w-100" onSubmit={handleSearchSubmit}>
                            <div className="input-wrapper">
                            <FormControl
                                type="search"
                                placeholder={autoText || (language==='kg')}
                                value={searchQuery}
                                onChange={handleSearchChange}
                                onFocus={() => setIsUserTyping(true)}
                                className="input-animated"

                            />
                            </div>
                            <Button variant="outline-light" type="submit" className="ms-2">
                                {language==='kg'?'Издөө':'Поиск'}
                            </Button>
                        </Form>
                        {showDropdown && (
                            filteredResults.length ? (
                                <ul className="list-group position-absolute w-100" style={{ top:'100%', zIndex:1050, maxHeight:200, overflowY:'auto' }}>
                                    {filteredResults.map(item => (
                                        <li key={item.model} className="list-group-item list-group-item-action" style={{ cursor:'pointer' }} onClick={() => handleResultClick(item)}>
                                            {highlightMatch(item.id, searchQuery)}
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <div className="list-group position-absolute w-100 p-2 bg-white text-muted" style={{ top:'100%', zIndex:1050 }}>
                                    {language==='kg'?'Табылган жок':'Ничего не найдено'}
                                </div>
                            )
                        )}
                    </div>
                    <div className="d-flex align-items-center gap-2">
                        <img src={KG} alt="KG" height="30" style={{ cursor:'pointer' }} onClick={() => changeLanguage('kg')} />
                        <img src={RU} alt="RU" height="30" style={{ cursor:'pointer' }} onClick={() => changeLanguage('ru')} />
                    </div>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header;
